import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetPageVideoStyle0 = gravityIconIndividualCss;

const GravityIconAssetPageVideo = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7392651413f53880625eed716c72088352ce9828', color: this.color, size: this.size }, h("svg", { key: '9d3de2246a6bd3759a95c7910901af5de1f596d4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '5fef2dcde1b77f97aa94f75d8085e3e1f5148dc9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17c.276 0 .5.21.5.471V17.53c0 .26-.224.471-.5.471h-17c-.276 0-.5-.21-.5-.471V4.47c0-.26.224-.471.5-.471Zm16 12.5v-11h-15v11h15Z", fill: "currentColor" }), h("path", { key: '4e3797a4ffcfe5238b8aec638633d2771426d3ae', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 9.5H7.5v3H12v-3Zm4 3.433c0 .267-.3.467-.5.334l-2-.767v1.25c0 .2-.05.25-.25.25h-7c-.2 0-.25-.05-.25-.25v-5.5c0-.2.05-.25.25-.25h7c.2 0 .25.05.25.25V9.5l2-.767c.2-.133.5 0 .5.267v3.933Z", fill: "currentColor" }))));
    }
};
GravityIconAssetPageVideo.style = GravityIconAssetPageVideoStyle0;

export { GravityIconAssetPageVideo as gravity_icon_asset_page_video };

//# sourceMappingURL=gravity-icon-asset-page-video.entry.js.map